import type { AllRouteEndpoints } from "../routeTypes";
export const engagementContentBlocksUpdateTagsCacheKeys: AllRouteEndpoints[] = ["/engagement/content_blocks"];
